export const operatorCustomerConstant = {
  GET_ALL_REQUEST: 'OPERATORS_CUSTOMERS_GET_ALL_REQUEST',
  GET_ALL_SUCCESS: 'OPERATORS_CUSTOMERS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'OPERATORS_CUSTOMERS_GET_ALL_FAILURE',
}
